export default __webpack_public_path__ + "static/media/flutter.83219c09.svg";